/*******************************************
       *  CORDINATE SHORT CUTS
       *******************************************
       */

//Stand Alone
function parsePolyStrings(ps) {
    var i, j, lat, lng, tmp, tmpArr,
        arr = [],
        //match '(' and ')' plus contents between them which contain anything other than '(' or ')'
        m = ps.match(/\([^\(\)]+\)/g);
    if (m !== null) {
        for (i = 0; i < m.length; i++) {
            //match all numeric strings
            tmp = m[i].match(/-?\d+\.?\d*/g);
            if (tmp !== null) {
                //convert all the coordinate sets in tmp from strings to Numbers and convert to LatLng objects
                for (j = 0, tmpArr = []; j < tmp.length; j += 2) {
                    lat = Number(tmp[j]);
                    lng = Number(tmp[j + 1]);
                    tmpArr.push(new google.maps.LatLng(lat, lng));
                }

                arr.push(tmpArr);
            }
        }
    }
    //array of arrays of LatLng objects, or empty array
    return arr;
}

//Stand Alone
function polygonCenter(poly) {
    var lowx,
        highx,
        lowy,
        highy,
        lats = [],
        lngs = [],
        vertices = poly.getPath();

    for (var i = 0; i < vertices.length; i++) {
        lngs.push(vertices.getAt(i).lng());
        lats.push(vertices.getAt(i).lat());
    }

    lats.sort();
    lngs.sort();
    lowx = lats[0];
    highx = lats[vertices.length - 1];
    lowy = lngs[0];
    highy = lngs[vertices.length - 1];
    var center_x = lowx + ((highx - lowx) / 2);
    var center_y = lowy + ((highy - lowy) / 2);
    return (new google.maps.LatLng(center_x, center_y));
}

//Stand Alone
function calculatePointFromPointAndDistance(lat1, lng1, d, brng) {
    lat1 = toRadians(lat1);
    lng1 = toRadians(lng1);

    var R = 6378100;
    var lat2 = Math.asin(
        Math.sin(lat1) * Math.cos(d / R) +
        Math.cos(lat1) * Math.sin(d / R) * Math.cos(brng)
    );

    var lng2 = lng1 + Math.atan2(
        Math.sin(brng) * Math.sin(d / R) * Math.cos(lat1),
        Math.cos(d / R) - Math.sin(lat1) * Math.sin(lat2)
    );
    return { lat: toDegrees(lat2), lng: toDegrees(lng2) };

}

//Stand Alone
function toDegrees(angle) {
    return angle * (180 / Math.PI);
}

//Stand Alone
function toRadians(angle) {
    return angle * (Math.PI / 180);
}

function pad(number, length) {
    var str = "" + number
    while (str.length < length) {
        str = '0' + str
    }
    return str
}


function urlArray(array) {
    var parts = [];

    for (var e in array) {
        parts.push(encodeURIComponent(e) + '=' +
            encodeURIComponent(array[e]))
    };

    return parts.join('&');

}

exports.parsePolyStrings = parsePolyStrings;
exports.polygonCenter = polygonCenter;
exports.calculatePointFromPointAndDistance = calculatePointFromPointAndDistance;
exports.toDegrees = toDegrees;
exports.toRadians = toRadians;
exports.pad = pad;

exports.urlArray = urlArray;